import React from 'react';
import { Link } from 'react-router';
import './LandingPage.css';

const LandingPage = () => {
    return (
        <div className="landing-container">
            <div className="hero-section">
                <h1>Plan your dream trip in just few minutes </h1>
                <p>Use AI to create the perfect trip plan personalized to your needs</p>
                <div className="cta-buttons">
                    <Link to="/creator" className="cta-button primary">Create you plan</Link>
                    {!localStorage.getItem('token') && (
                        <Link to="/register" className="cta-button secondary">Register</Link>
                    )}
                </div>
            </div>
            <div className="features-section">
                <div className="feature-card">
                    <h3>Inteligent Trips</h3>
                    <p>Optimized connections between attractions</p>
                </div>
                <div className='feature-card'>
                    <h3>Save time</h3>
                    <p>Your trip plan ready in just a minute</p>
                </div>
                <div className='feature-card'>
                    <h3>Personalized</h3>
                    <p>Attractions optimized to your needs</p>
                </div>
            </div>
        </div>
    )
}

export default LandingPage;